import {
  AllowedIdentityProviders,
  AuthClientItem,
  IAuthClientsResponse,
  urls,
  useJ1AuthFetch,
} from '@jupiterone/jupiter-web-toolkit';

const useAuthClients = () => {
  const { authFetch } = useJ1AuthFetch();
  function normalizeAuthClientItem(authClient: AuthClientItem) {
    if (!authClient.callbackUrls.length) {
      authClient.callbackUrls = [urls.appRedirect];
    }

    if (!authClient.logoutUrls.length) {
      authClient.logoutUrls = [urls.defaultOAuthLogoutUrl];
    }

    if (!authClient.identityProviders.length) {
      authClient.identityProviders = [AllowedIdentityProviders.CUSTOM];
    }

    return authClient;
  }

  async function getAuthClients(): Promise<IAuthClientsResponse> {
    const results = await authFetch(urls.authClients, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await results.json();
  }

  async function updateAuthClient(
    authClient: AuthClientItem
  ): Promise<AuthClientItem> {
    authClient = normalizeAuthClientItem(authClient);
    const results = await authFetch(`${urls.authClients}/${authClient.id}`, {
      method: 'PUT',
      body: JSON.stringify(authClient),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await results.json();
  }

  async function deleteAuthClient(id: string): Promise<AuthClientItem> {
    const results = await authFetch(`${urls.authClients}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await results.json();
  }

  async function createAuthClient(
    authClient: AuthClientItem
  ): Promise<AuthClientItem> {
    authClient = normalizeAuthClientItem(authClient);
    const results = await authFetch(urls.authClients, {
      method: 'POST',
      body: JSON.stringify(authClient),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await results.json();
  }
  return {
    normalizeAuthClientItem,
    getAuthClients,
    updateAuthClient,
    deleteAuthClient,
    createAuthClient,
  };
};

export default useAuthClients;
